
import * as actionTypes from './action-types';

export const errorHandler = error => ({
    type: actionTypes.SERVER_ERROR,
    payload: {object: error},
});
